var render = function render(){var _vm=this,_c=_vm._self._c;return _c('AlModal',{attrs:{"open-modal":_vm.showModal,"data-testid":"navigate-away-modal","config":_vm.config},on:{"close-modal":_vm.cancel,"close":_vm.cancel}},[_c('Localization',{attrs:{"message":_vm.body}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }